/**
 * Like Array.isArray but ensures type narrows to a ReadonlyArray
 * @param   arg  Any argument, will be
 * @return       True or false but casts a value appropriately
 */
export function isArray<T = any>(arg: any): arg is ReadonlyArray<T> {
    return Array.isArray(arg);
}
